(function() {
    "use strict";

    angular.module("eSign").directive("callbackIframe", ['$window', '$sce', 'appConfig', function($window, $sce, appConfig) {
    return {
      restrict: 'E',
      replace: 'true',
      template: '<iframe class="bankid-frame" ng-src="{{trustedSource}}"></iframe>',
      link: function(scope, element, attrs) {
        scope.$watch("source", function(newValue) {
          if(newValue) {
            scope.trustedSource = $sce.trustAsResourceUrl(newValue);
          }
        });

          $window.eSign = $window.eSign || {
          loginSuccess: function() {
            scope.$apply(function() {
              if(scope.callback) {
                scope.callback(appConfig.chooseSignTaskUrl);
              }
            });
          },
          loginFail: function() {
            scope.$apply(function() {
              if(scope.callback) {
                scope.callback(appConfig.loginErrorUrl);
              }
            });
          },
          whiteWash: function() {
              scope.$apply(function() {
                  if (scope.callback) {
                      scope.callback(appConfig.whiteWashUrl);
                  }
              });
          }
        };
     },
     scope: {
       source: '=source',
       callback: '='
     }
    };
  }]);

}());
